import { StrictNullable } from '@/shared/types/app.types'
import { InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { InvoiceReceiptResponse } from '@/api/services/billing/invoice-receipt/billing-invoice-receipt.dto'
import { AppliedBillableConceptResponse } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'

export interface BillingModalInvoiceReceiptParams {
    invoice?: InvoiceResponse
    invoiceReceipt?: InvoiceReceiptResponse
    selectionMode?: boolean
}

export interface BillingModalInvoiceReceiptState {
    invoice: StrictNullable<InvoiceResponse>
    invoiceReceipt: StrictNullable<InvoiceReceiptResponse>
    selectionMode: boolean
    addToMode: boolean
    conceptsTotalCount: number
    appliedBillableConcepts: AppliedBillableConceptResponse[]
}
export const initialBillingModalInvoiceReceiptState =
    (): BillingModalInvoiceReceiptState => ({
        invoice: null,
        invoiceReceipt: null,
        selectionMode: true,
        addToMode: false,
        conceptsTotalCount: 0,
        appliedBillableConcepts: []
    })
